<div class="cal-picker w-full">
	<div class="cal-picker-header flex flex-row justify-between items-center content-center">
		<button (click)="changeMonth(-1)" class="cal-nav-btn cursor-pointer bg-transparent border-0 p-0">
			<lucide-icon name="chevron-left" [size]="18"></lucide-icon>
		</button>
		<h1 class="cal-picker-title text-corporate-3 text-[13px] font-semibold">{{dateSelect | date:'MMMM, yyyy'}}</h1>
		<button (click)="changeMonth(1)" class="cal-nav-btn cursor-pointer bg-transparent border-0 p-0">
			<lucide-icon name="chevron-right" [size]="18"></lucide-icon>
		</button>
	</div>
	<ol class="cal-grid">
		<li *ngFor="let day of week" class="cal-weekday text-corporate-3 opacity-60">{{day | slice:0:3}}</li>

        <li (click)="clickDay(day)" [style.gridColumnStart]="first ? day?.indexWeek : 'auto'"
         *ngFor="let day of monthSelect;let first = first" class="cal-day">
			<span *ngIf="!setDay"  [ngClass]="{'dayCurrent': this.daySelected==day.value , 'dayNoSelected' : this.daySelected!=day.value }">{{day?.value}}</span>
			<span *ngIf="setDay" [ngClass]="{'daySelected': valSel==day.value , 'dayNoSelected' : valSel!=day.value && (this.today!=day.value || this.today==day.value && this.monthCurrent!=this.monthChanged ),'dayCurrent': this.today==day.value && this.monthCurrent==this.monthChanged  }">{{day?.value}}</span>
		</li>
	</ol>
</div>